import { Directive, forwardRef, OnChanges, SimpleChanges, Type, input } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[tdWbSecuritiesTransfersBackendValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<SecuritiesTransfersBackendValidatorDirective> => SecuritiesTransfersBackendValidatorDirective),
    multi: true
  }]
})
export class SecuritiesTransfersBackendValidatorDirective implements Validator, OnChanges {
  readonly tdWbSecuritiesTransfersBackendValidator = input<string>(undefined);
  // Tuple with <selectedFrom, list of toAccounts found>
  private onChange: () => void;

  validate(): ValidationErrors | null {
    const tdWbSecuritiesTransfersBackendValidator = this.tdWbSecuritiesTransfersBackendValidator();
    if (tdWbSecuritiesTransfersBackendValidator === undefined) {
      return null; // bad input, no errors
    }
    return { [tdWbSecuritiesTransfersBackendValidator]: true };
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes !== undefined && this.onChange !== undefined) {
      this.onChange();
    }
  }
}
